import type { ReactNode } from 'react'
/** Literal panel grouping extracted from the original lifecycle card. */
export function InsightPanels({ children, collapseBelow = 480 }: { children: ReactNode; collapseBelow?: number }) {
  const columns = `@container (inline-size <= ${collapseBelow}px) 1fr, 1fr 1fr`
  return (
    <s-grid gridTemplateColumns={columns} gap="base">
      {children}
    </s-grid>
  )
}
export function InsightPanel({ children }: { children: ReactNode }) {
  return (
    <s-box background="subdued" borderRadius="base" padding="base" data-insight-panel="true">
      <s-stack gap="base">{children}</s-stack>
    </s-box>
  )
}
